import React, { useState, useEffect } from "react";
import { getVaultBalances } from "../../../networking/NetworkingWidget";

export const useVaultBalancesData = (vaultId) => {
    const [columnsData, setColumnsData] = useState([]);
    const [columnDetail, setColumnDetail] = useState({});
    const [refreshTrigger, setRefreshTrigger] = useState(0);
    
    useEffect(() => {
        let isMounted = true;

        const fetchData = async () => {
            if (!vaultId) {
                if (isMounted) setColumnsData([]);
                return;
            }

            const response = await getVaultBalances(vaultId);

            if (response && response.result) {
                let parsedColumnDetail = {};
                if (response.columnDetail) {
                    try{
                        const columnDetailObj = JSON.parse(response.columnDetail);
                        parsedColumnDetail = Object.keys(columnDetailObj).reduce((acc, key) => {
                            const value = columnDetailObj[key];
                            const titleMatch = value.match(/title:([^,]+)/);
                            const widthMatch = value.match(/width:([^,]+)/);
                            acc[key] = {
                                title: titleMatch ? titleMatch[1] : key,
                                width: widthMatch ? widthMatch[1] : 'auto'
                            };
                            return acc;
                        }, {});
                    } catch (e) {
                        console.error('Error parsing columnDetail:', e);
                    }
                }
                const mappedData = response.result;

                const grouped = mappedData.reduce((acc, item) => {
                    if (!acc[item.Currency]) acc[item.Currency] = [];
                    acc[item.Currency].push(item);
                    return acc;
                }, {});

                const totalsResponse = await getVaultBalances("");
                let totalsByCurrency = {};

                if (totalsResponse && totalsResponse.result){
                    totalsResponse.result.forEach(item => {
                        const currencyMatch = item.Currency.match(/^([A-Z]{3})\s*\(/);
                        const currencyCode = currencyMatch ? currencyMatch[1] : item.Currency;
                        totalsByCurrency[currencyCode] = {
                        ...item,
                        Currency: currencyCode,
                        displayCurrency: item.Currency
                        };
                    });
                    if (totalsResponse.result.length > 0) {
                        const totalsKeys = Object.keys(totalsResponse.result[0]);
                        totalsKeys.forEach(key => {
                            if (!parsedColumnDetail[key]) {
                                parsedColumnDetail[key] = key;
                            }
                        });
                    }
                }
                setColumnDetail(parsedColumnDetail);

                const withTotals = [];
                const allCurrencies = new Set(Object.keys(totalsByCurrency));
                const sortedCurrencies = Array.from(allCurrencies).sort();

                sortedCurrencies.forEach(currency =>{
                    const totalItem = totalsByCurrency[currency];
                    const total = {
                        ...totalItem,
                        "Denomination Description": "Total"
                    };
                    withTotals.push(total);
                    if (grouped[currency]) {
                        grouped[currency].sort((a, b) => {
                            const aVal = parseFloat(a["Denomination Description"]) || 0;
                            const bVal = parseFloat(b["Denomination Description"]) || 0;
                            return aVal - bVal;
                        });
                        withTotals.push(...grouped[currency]);
                    }
                })

                if (isMounted) { setColumnsData(withTotals); } 
            } else {
                if (isMounted) { setColumnsData([]); }
            }
        }

        fetchData();

        return () => {
            isMounted = false;
        };
    }, [vaultId, refreshTrigger])

    return {
        columnsData,
        columnDetail,
        refresh: () => setRefreshTrigger(prev => prev + 1)
    };
}